import { Link } from "react-router-dom";
import { Layout } from "../Layout";
import { Seo } from "../../seo/Seo";

export default function NotFound() {
  return (
    <Layout>
      <Seo
        title="Page not found — KR Studio"
        description="The page you're looking for doesn't exist or has moved."
        noindex
      />
      <section className="page-hero notfound" data-testid="notfound-page">
        <div className="wrap">
          <span className="eyebrow"><span className="sq" /> 404</span>
          <h1 className="page-title" data-testid="notfound-title">Page not found</h1>
          <p className="notfound-text">The page you're looking for doesn't exist or has moved.</p>
          <div className="hero-actions">
            <Link to="/" className="btn btn-primary" data-testid="notfound-home-link">Back to home</Link>
            <Link to="/#work" className="btn btn-outline" data-testid="notfound-work-link">See our work</Link>
            <Link to="/contact" className="btn btn-outline" data-testid="notfound-contact-link">Contact</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
